import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { AddOnPricingBreakdown } from "./component";
import {
  predictionSelector,
  selectedFareDetailsSelector,
  selectedCfarOfferPricesSelector,
  selectedDisruptionProtectionOfferPricesSelector,
  customizeCheckoutBreakdownTotalPricesSelector,
  selectedDiscountedCfarOfferPricesSelector,
  selectedCfarOfferCoverageSelector,
  selectedDisruptionProtectionIdSelector,
  selectedChfarOfferPricesSelector,
  selectedDisruptionProtectionOfferProductVariantSelector,
} from "../../../reducer";
import { getTripCategory } from "../../../../search/reducer";
import { IStoreState } from "../../../../../reducers/types";
import {
  isAirOfferRedesignEnabledSelector,
  isCfarCoMerchEnabledSelector,
  getPriceDropRefundTypeSelector,
} from "../../../../ancillary/reducer";
import { containsSelfTransferLayoverFareSegment } from "redmond";

const mapStateToProps = (state: IStoreState) => {
  const selectedFare = selectedFareDetailsSelector(state);
  const isVITripSelected = selectedFare
    ? containsSelfTransferLayoverFareSegment([selectedFare])
    : false;

  return {
    selectedFare,
    totalPrices: customizeCheckoutBreakdownTotalPricesSelector(state),
    tripCategory: getTripCategory(state),
    prediction: predictionSelector(state),
    cfarOfferPrices: selectedCfarOfferPricesSelector(state),
    cfarOfferCoverage: selectedCfarOfferCoverageSelector(state),
    discountedCfarOffer: selectedDiscountedCfarOfferPricesSelector(state),
    chfarOfferPrices: selectedChfarOfferPricesSelector(state),
    disruptionProtectionOfferPrices:
      selectedDisruptionProtectionOfferPricesSelector(state),
    isAirOfferRedesignEnabled: isAirOfferRedesignEnabledSelector(state),
    isCfarCoMerchEnabled: isCfarCoMerchEnabledSelector(state),
    selectedDisruptionProtectionId:
      selectedDisruptionProtectionIdSelector(state),
    priceDropRefundType: getPriceDropRefundTypeSelector(state),
    isVITripSelected,
    fdaProductVariant:
      selectedDisruptionProtectionOfferProductVariantSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AddOnPricingBreakdownConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedAddOnPricingBreakdown = withRouter(
  connector(AddOnPricingBreakdown)
);
